import { doc, getDoc, writeBatch } from 'firebase/firestore';

export const QR_INDEX_COLLECTION = 'qrIndex';

/** SHA-256 en hex del código (64 caracteres minúsculas en esta app). */
export function isLikelyQrHexId(qrValue) {
  return typeof qrValue === 'string' && /^[a-f0-9]{64}$/i.test(qrValue);
}

/**
 * Mantiene un índice qrValue → documento padre para lecturas sin listar toda la colección de órdenes.
 */
export async function syncQrIndexForOrder(db, parentCollection, parentDocId, cartItems) {
  if (!cartItems?.length || !parentDocId) return;
  let batch = writeBatch(db);
  let n = 0;
  for (const item of cartItems) {
    const qrValue = item.qrValue;
    if (!isLikelyQrHexId(qrValue)) continue;
    const ref = doc(db, QR_INDEX_COLLECTION, qrValue.toLowerCase());
    batch.set(ref, { parentCollection, parentDocId }, { merge: true });
    n += 1;
    if (n >= 400) {
      await batch.commit();
      batch = writeBatch(db);
      n = 0;
    }
  }
  if (n > 0) await batch.commit();
}

/**
 * Resuelve un QR público o de escáner: qrIndex + get del padre + ítem en cartItems.
 */
export async function resolveQrFromFirestore(db, qrValue) {
  if (!isLikelyQrHexId(qrValue)) return null;
  const id = qrValue.toLowerCase();
  const indexSnap = await getDoc(doc(db, QR_INDEX_COLLECTION, id));
  if (!indexSnap.exists()) return null;
  const { parentCollection, parentDocId } = indexSnap.data() || {};
  if (!parentCollection || !parentDocId) return null;
  const parentSnap = await getDoc(doc(db, parentCollection, parentDocId));
  if (!parentSnap.exists()) return null;
  const data = parentSnap.data();
  const item = (data.cartItems || []).find((i) => i.qrValue && i.qrValue.toLowerCase() === id);
  if (!item) return null;
  let eventIsActive = null;
  if (item.eventId || data.eventId) {
    const eventSnap = await getDoc(doc(db, 'events', item.eventId || data.eventId));
    eventIsActive = eventSnap.exists() && eventSnap.data()?.isActive === true;
  }
  return {
    ...item,
    orderNumber: data.orderNumber,
    nombre: item.nombre || data.nombre,
    docId: parentSnap.id,
    collectionName: parentCollection,
    cartItems: data.cartItems,
    saleCreatedByUid: data.createdByUid || null,
    saleCreatedByEmail: data.createdByEmail || null,
    saleCreatedByName: data.createdByName || null,
    saleCreatedByRole: data.createdByRole || null,
    eventIsActive,
  };
}
